<template>
  <div>
    <div
      class="inventory-create"
      v-loading="loading"
      v-if="dataPermission.includes('NSH_ODM_IO_CREATE')"
    >
      <ValidationObserver ref="storageCreat">
        <b-form @submit.stop.prevent="">
          <LayoutStorage @btnBack="backLinkTo()">
            <template v-slot:actions>
              <div class="d-flex flex-row">
                <el-button class="n-btn" type="primary" plain @click="checkSubmit('ruleForm','draft')"
                  >Lưu đơn</el-button
                >
                <el-button class="n-btn" type="primary" @click="checkSubmit('ruleForm','success')"
                  >Xác nhận</el-button
                >
              </div>
            </template>

            <template v-slot:title> Tạo đơn nhập kho</template>

            <template v-slot:content>
              <LayoutCard>
                <LayoutCardTitle>Thông tin cơ bản </LayoutCardTitle>
                <el-form
                  :model="ruleForm"
                  :rules="rules"
                  ref="ruleForm"
                  label-width="184px"
                  style="width:100%"
                >
                  <el-form-item label="Mã đơn" prop="orderNo">
                    <el-input v-model="ruleForm.orderNo"></el-input>
                  </el-form-item>
                </el-form>
                <LayoutFieldSet>
                  <LayoutField :required="true">
                    <template #label>Lý do nhập</template>
                    <template #input>
                      <BaseInput
                        v-model="Order.furtherInstructions[0].params.reason"
                        placeholder="Lý do nhập"
                        :rules="'required'"
                        name="Lý do"
                      />
                    </template>
                  </LayoutField>
                </LayoutFieldSet>

                <LayoutFieldSet>
                  <LayoutField>
                    <template #label>Ghi chú</template>
                    <template #input>
                      <BaseTextarea
                        placeholder="Ghi chú"
                        name="Ghi chú"
                        :rules="'lBetween:3,255'"
                        :value="Order.furtherInstructions[0].params.note"
                        @value="
                          Order.furtherInstructions[0].params.note = $event
                        "
                      />
                    </template>
                  </LayoutField>
                </LayoutFieldSet>
              </LayoutCard>

              <LayoutCard>
                <LayoutCardTitle>Nhà cung cấp</LayoutCardTitle>

                <LayoutFieldSet>
                  <LayoutField>
                    <template #label>Nhà cung cấp</template>
                    <template #input>
                      <BaseSelect
                        :options="suppliers"
                        label="name"
                        placeholder="Chọn nhà cung cấp"
                        v-model="Order.partyB.name"
                        @select="Order.partyB = $event"
                        :hideRemove="true"
                        :showADD="true"
                      >
                        <template slot="showADD">
                          <div
                            @click="isPopupAddSupplier = true"
                            style="
                              color: #3e69f6;
                              cursor: pointer;
                              font-weight: bold;
                              padding: 12px 16px;
                            "
                          >
                            Thêm nhà cung cấp
                          </div>
                        </template>
                      </BaseSelect>
                    </template>
                  </LayoutField>
                </LayoutFieldSet>

                <LayoutFieldSet v-if="Order.partyB.name">
                  <LayoutField>
                    <template #label> Email nhà cung cấp</template>
                    <template #input>
                      <div class="d-flex align-items-center h-100">
                        {{ Order.partyB.email ? Order.partyB.email : "__" }}
                      </div>
                    </template>
                  </LayoutField>
                  <LayoutField>
                    <template #label>Số điện thoại</template>
                    <template #input>
                      <div class="d-flex align-items-center h-100">
                        {{ Order.partyB.phoneNo ? Order.partyB.phoneNo : "__" }}
                      </div>
                    </template>
                  </LayoutField>
                </LayoutFieldSet>

                <LayoutFieldSet v-if="Order.partyB.name">
                  <LayoutField>
                    <template #label>Địa chỉ</template>
                    <template #input>
                      <div class="d-flex align-items-center h-100">
                        {{ Order.partyB.address ? Order.partyB.address : "__" }}
                      </div>
                    </template>
                  </LayoutField>
                </LayoutFieldSet>
              </LayoutCard>

              <LayoutCard>
                <LayoutCardTitle>Danh sách sản phẩm</LayoutCardTitle>

                <LayoutFieldSet>
                  <LayoutField>
                    <template #label>Chi nhánh</template>
                    <template #input>
                      <el-select
                        v-model="locationID"
                        placeholder="Hãy lựa chọn chi nhánh"
                        @change="changeLocationID"
                      >
                        <el-option
                          v-for="(location, index) in locations"
                          :key="index"
                          :label="location.name"
                          :value="location.coLocationId"
                        />
                      </el-select>
                    </template>
                  </LayoutField>
                  <LayoutField>
                    <template #label>Kho</template>
                    <template #input>
                      <el-select
                        v-model="inventoryID"
                        placeholder="Hãy lựa chọn kho"
                      >
                        <el-option
                          v-for="(inventory, index) in inventories"
                          :key="index"
                          :label="inventory.name"
                          :value="inventory.coInventoryId"
                        />
                      </el-select>
                    </template>
                  </LayoutField>
                </LayoutFieldSet>

                <BaseSearchSelect
                  :options="variations"
                  :variation="true"
                  label="name"
                  quantity="quantity"
                  placeholder="Tìm kiếm phiên bản sản phẩm"
                  @select="addVariation($event)"
                  :showADD="true"
                >
                  <template #showADD>
                    <div
                      @click="isPopupAddItem = true"
                      style="color: #3e69f6; cursor: pointer; font-weight: bold"
                    >
                      Thêm sản phẩm
                    </div>
                  </template>
                </BaseSearchSelect>

                <el-dropdown placement="top-start" trigger="click">
                  <div class="dropdown-link">
                    Thao tác nhanh<i
                      class="el-icon-arrow-down el-icon--right"
                    ></i>
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                      <popup-type-item @response="onResponse"></popup-type-item>
                    </el-dropdown-item>
                    <el-dropdown-item v-if="allowDisplay">
                      <popup-set-value
                        :selected="selected"
                        type="quantity"
                        text="Áp dụng nhanh số lượng"
                        @result="onResult"
                      ></popup-set-value>
                    </el-dropdown-item>
                    <el-dropdown-item v-if="allowDisplay">
                      <popup-set-value
                        :selected="selected"
                        type="price"
                        text="Áp dụng nhanh giá nhập"
                        @result="onResult"
                      ></popup-set-value>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <div
                  style="overflow-x: auto; max-width: 100%; width: 100%"
                  class="is-valid-table"
                >
                  <b-table
                    :items="Order.lineItem"
                    :fields="fieldsVariation"
                    :key="updateUI"
                  >
                    <template
                      v-slot:head(selected)
                      v-if="Order.lineItem.length > 0"
                    >
                      <b-form-checkbox
                        v-model="checkboxAll"
                        @change="selectAll"
                      />
                    </template>
                    <template #cell(selected)="data">
                      <b-form-checkbox
                        v-model="selected"
                        :value="data.item"
                        @change="checkItem(data.item)"
                      />
                    </template>
                    <template #table-caption>
                      <div class="emptyTable" v-if="Order.lineItem.length == 0">
                        <IconBoxEmpty />
                        <p>Chưa có sản phẩm nào được chọn.</p>
                      </div>
                    </template>

                    <template #row-details="data">
                      <div>
                        <el-tag
                          v-for="(seria, index) in data.item.lineItemOtherInfo
                            .seriesNo"
                          :key="index"
                          closable
                          @close="handleCloseSeria(seria, data.index)"
                          class="tag"
                        >
                          {{ seria }}
                        </el-tag>

                        <div
                          class="d-flex flex-row align-items-center"
                          style="padding-top: 10px"
                          v-if="data.item.useImeiAndSerial"
                        >
                          <label style="width: 120px; padding-top: 8px"
                            >Seria/Emei</label
                          >

                          <BaseInput
                            v-model="data.item.serieNew"
                            placeholder="Nhập seria/imei"
                            style="width: 30%; margin-right: 10px"
                            type="serial"
                            :validate="data.item.lineItemOtherInfo.validate"
                            @enter="btnAddSeria(data.index, data.item.serieNew)"
                          />

                          <el-button
                            type="primary"
                            size="small"
                            style="height: 45.5px"
                            @click="btnAddSeria(data.index, data.item.serieNew)"
                            plain
                            :disabled="data.item.serieNew === ''"
                            :loading="data.item.btnLoading"
                          >
                            Thêm
                          </el-button>
                        </div>
                        <div
                          class="d-flex flex-row align-items-center"
                          style="padding-top: 10px"
                          v-if="data.item.useProductBatch"
                        >
                          <div>
                            <div style="padding-bottom: 20px">
                              <base-tag
                                v-for="(expiration, index) in data.item
                                  .expirationSelect"
                                :key="index"
                                type="info"
                                closeTag
                                :value="expiration"
                                @close="handleCloseExp(expiration, data.item)"
                                style="margin-right: 5px; margin-top: 8px"
                              >
                                {{ expiration.batchCode }} - HSD:
                                {{
                                  timeFormatDate(expiration.expirationDate)
                                }}
                                - SL:
                                {{ expiration.quantityChoose }}
                              </base-tag>
                            </div>
                            <div style="display: flex">
                              <b style="padding-right: 20px; align-self: center"
                                >Số lô:</b
                              >
                              <popup-select-expried
                                :item="data.item"
                                :selected="data.item.expirationSelect"
                                @batchSelect="onBatchSelect"
                                style="margin-right: 10px"
                              />
                              <popup-add-expried
                                :item="data.item"
                                :selected="data.item.expirationSelect"
                                @batchs="onBatchs"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>

                    <template #cell(variationId)="data">
                      {{ data.index + 1 }}
                    </template>

                    <template #cell(amount)="data">
                        <BaseInput placeholder="Giá nhập" v-model="data.item.prices.importPrice" type="unit"
                        @value="calculateTotalAmount()" @input="handleChangeImportPrice(data.item)"
                        :validate="data.item.validate.importPrice" />
                    </template>

                    <template #cell(quantity)="data">
                      <b v-if="data.item.useImeiAndSerial || data.item.useProductBatch">
                        {{ data.item.quantity }}
                      </b>
                      <BaseInput v-else placeholder="Nhập số lượng" v-model="data.item.quantity" type="unit"
                        @value="calculateTotalAmount()" @input="handleChangeImportPrice(data.item)"
                        :validate="data.item.validate.quantity" />
                    </template>

                    <template #cell(totalAmount)="data">
                      <div>
                        {{
                          (checkNumReplaceComma(data.item.quantity) *
                            checkNumReplaceComma(data.item.prices.importPrice))
                            | formatMoney
                        }}
                      </div>
                    </template>

                    <template #cell(fieldEdit)="data">
                      <svg
                        width="28"
                        height="28"
                        viewBox="0 0 28 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style="cursor: pointer"
                        @click="removeVariation(data.index)"
                      >
                        <path
                          d="M8.31361 17.9341C7.94447 18.3032 7.92689 18.9624 8.3224 19.3403C8.70033 19.7358 9.3683 19.7183 9.73744 19.3491L14.0001 15.0864L18.2628 19.3491C18.6408 19.7271 19.2911 19.7358 19.6691 19.3403C20.0646 18.9624 20.0558 18.3032 19.6779 17.9253L15.4152 13.6626L19.6779 9.40869C20.0558 9.02197 20.0646 8.37158 19.6691 7.99365C19.2911 7.59814 18.6408 7.60693 18.2628 7.98486L14.0001 12.2476L9.73744 7.98486C9.3683 7.61572 8.70033 7.59814 8.3224 7.99365C7.92689 8.37158 7.94447 9.03076 8.31361 9.3999L12.5763 13.6626L8.31361 17.9341Z"
                          fill="#888888"
                        />
                      </svg>
                    </template>
                  </b-table>
                </div>

                <div class="total-amount">
                  <span>Tổng tiền: {{ totalAmount | formatMoney }} </span>
                </div>
              </LayoutCard>
            </template>
          </LayoutStorage>
        </b-form>
      </ValidationObserver>
      <!-- Popup xác nhận -->
      <el-dialog
        title="Xác nhận đơn"
        :visible.sync="confirmVisible"
        width="30%"
      >
        <div class="text-center">
          <IconDocumentChecked />
        </div>
        <p style="word-break: break-word">
          Đơn được xác nhận sẽ không chỉnh sửa nội dung được nữa. Hãy chắc chắn
          rằng bạn đã đọc kỹ trước khi đồng ý
        </p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="confirmVisible = false">Quay lại</el-button>
          <el-button
            type="primary"
            @click="(printBarcodeVisible = true), successLinkTo"
            >Xác nhận</el-button
          >
        </span>
      </el-dialog>
      <!-- Popup link sang in mã vạch-->
      <el-dialog
        title="In mã vạch"
        :visible.sync="printBarcodeVisible"
        width="30%"
        :before-close="handleClose"
      >
        <div class="text-center">
          <img src="@/assets/images/box_barcode.svg" />
        </div>
        <p style="word-break: break-word">
          Bạn có muốn in mã vạch cho những sản phẩm vừa nhập?
        </p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="returnDetail">Để sau</el-button>
          <el-button type="primary" @click="clickBarcodeChooseMore"
            >In ngay</el-button
          >
        </span>
      </el-dialog>
      <BasePopupSuccess
        id="checkin-success"
        title="Tạo đơn nhập kho thành công"
        @submit="successLinkTo"
      >
        <template #content> Đơn nhập kho đã được tạo. </template>
      </BasePopupSuccess>

      <PopupAddSupplier
        :isPopup="isPopupAddSupplier"
        @getValue="getListSupplier($event)"
      />

      <PopupAddItem
        :isPopup="isPopupAddItem"
        @getValue="getListProduct($event)"
      />

      <LayoutPopup id="Chua-nhap-san-pham" size="small">
        <template #title>Bạn chưa nhập sản phẩm!</template>
        <template #content>
          <div class="icon-success">
            <IconBox />
          </div>
          <div class="content-success">
            Vui lòng nhập sản phẩm vào danh sách để tạo đơn.
          </div>
        </template>
        <template #control-right>
          <BaseButton size="sm" @click="hidePopup('Chua-nhap-san-pham')">
            Đồng ý
          </BaseButton>
        </template>
      </LayoutPopup>

      <LayoutPopup id="Canh-bao-xac-nhan-phieu-hang" size="small">
        <template #title>Xác nhận đơn</template>
        <template #content>
          <div class="icon-success">
            <IconDocumentChecked />
          </div>
          <div class="content-success">
            Đơn được xác nhận sẽ không chỉnh sửa nội dung được nữa. Hãy chắc
            chắn rằng bạn đã đọc kỹ trước khi đồng ý.
          </div>
        </template>
        <template #control-right>
          <BaseButton
            size="sm"
            variant="secondary"
            @click="hidePopup('Canh-bao-xac-nhan-phieu-hang')"
          >
            Quay lại
          </BaseButton>
          <BaseButton size="sm" @click="submitForm()"> Xác nhận </BaseButton>
        </template>
      </LayoutPopup>
    </div>
    <TheLayout v-else>
      <NotPermision></NotPermision>
    </TheLayout>
  </div>
</template>

<script>
import LayoutStorage from "@/router/layouts/storage.vue";
import IconBoxEmpty from "@/components/icons/icon_box_empty.vue";
import IconBox from "@/components/icons/icon_box.vue";
import IconDocumentChecked from "@/components/icons/icon_document_checked.vue";
import PopupAddSupplier from "./components/popup-add-supplier.vue";
import PopupAddItem from "./components/popup-add-item.vue";
import PopupSelectExpried from "@/components/popup-add-quick/popup-select-expried.vue";
import PopupAddExpried from "@/components/popup-add-quick/popup-add-expried.vue";
import { numFormat } from "@/pages/V2/pos/utils/pos.js"

import { validSeria } from "@/utils/validate";
import { checkSerialExist } from "@/mixins/storage/checkSerial";
import getListLocation from "@/mixins/location/getListLocation";
import getDetailItem from "@/mixins/items/getDetailItem";
import getSuppliers from "@/mixins/suppliers/gerSuppliers";
import reqCheckinOrder from "@/mixins/storage/reqCheckinOrder";
import searchOrderNo from "@/mixins/storage/searchOrderNo";
import changeStatusOrder from "@/mixins/storage/changeStatusOrder";

import { ProductService } from "@/services/nextshop/product.service";
import { StorageService } from "@/services/nextshop/storage.service";
import PopupSetValue from "@/components/popup-add-quick/popup-set-value";
import PopupTypeItem from "@/components/popup-add-quick/popup-type-item.vue";
import { removeDot } from "../../utils/mapping";
import enterKeyMinus from "@/pages/V2/pos/mixins/pos.js"
import {
  getDataPermission,
  getInventoryIdCurrent,
  getLocationID,
  getMerchanIDCurrent,
} from "../../utils/auth";

export default {
  components: {
    LayoutStorage,
    IconBox,
    IconDocumentChecked,
    IconBoxEmpty,
    PopupAddSupplier,
    PopupAddItem,
    PopupSetValue,
    PopupTypeItem,
    PopupSelectExpried,
    PopupAddExpried,
  },

  mixins: [
    getListLocation,
    getDetailItem,
    getSuppliers,
    reqCheckinOrder,
    searchOrderNo,
    changeStatusOrder,
    enterKeyMinus
  ],

  data() {
    var checkOrderNo = (rule, value, callback) => {
      setTimeout(() => {
        if (value == "") {
          callback();
        } else {
          const str = value.trim();
          var vn =
            /[ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂẾưăạảấầẩẫậắằẳẵặẹẻẽềềểếỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/;
          const checkVN = vn.test(str);
          const conditions = /^[a-zA-Z0-9\-\\_]{2,50}$/g;
          if (conditions.test(str) && !checkVN) {
            callback();
          } else {
            callback(new Error(`Vui lòng nhập mã đơn có ký tự không dấu, không chứa các kí tự đặc biệt trừ "-" và "_"`));
          }
        }
      }, 1000);
    };
    return {
      ruleForm: {
        orderNo: "",
      },
      rules: {
        orderNo: [
          {
            min: 2,
            max: 50,
            message: "Vui lòng nhập mã đơn có độ dài từ 2 đến 50",
            trigger: "blur",
          },
          { validator: checkOrderNo, trigger: "blur" },
        ],
      },
      numFormat: numFormat,
      textSearch: "",
      updateUI: 1,
      checkboxAll: false,
      selected: [],
      confirmVisible: false,
      loading: false,
      btnLoading: false,
      isPopupAddSupplier: false,
      isPopupAddItem: false,
      itemID: this.$route.params.itemID,
      query : this.$route.query,
      orderID: "",
      dataPermission: getDataPermission(),
      dataVariations: [],
      variations: [],
      locations: [],
      suppliers: [],
      inventories: [],
      lineInfo: {},
      seriaNew: "",
      txtSearch: "",
      locationID: getLocationID(),
      inventoryID: getInventoryIdCurrent(),
      inventoryName: "",
      merchantId: "",
      typeSubmit: "",
      totalAmount: 0,
      validate: {
        errorPartyB: "",
        orderNo: "",
      },
      paramItems: {
        queryString: "",
        merchantId: getMerchanIDCurrent(),
        pagingAndSorting: {
          limit: 100,
          lastIndex: "",
          sortOrder: "DESC",
        },
      },
      Order: {
        orderNo: "",
        locationId: "",
        currency: "VND",
        furtherInstructions: [
          {
            key: "CHECK_IN",
            cat: "INVENTORY_OPERATION",
            note: "",
            params: {
              employeeId: "61f1ea1db5abae0e85c17cff",
              employeeName: "tran",
              employeePhone: "03324873333",
              reason: "",
              note: "",
              referenceCode: "mã tham chiếu",
            },
          },
        ],
        note: "",
        lineItem: [],
        partyA: {},
        partyB: {
          name: "",
        },
      },
      fieldsVariation: [
        {
          label: "",
          key: "selected",
          thStyle: {
            width: "10%",
            "min-width": "60px",
            "word-break": "break-word",
          },
        },
        {
          label: "Phiên bản sản phẩm",
          key: "variationName",
          thStyle: {
            width: "25%",
            "min-width": "240px",
            "word-break": "break-word",
          },
        },
        {
          label: "Giá nhập",
          key: "amount",
          thStyle: {
            width: "25%",
            "min-width": "180px",
            "word-break": "break-word",
          },
        },
        {
          label: "Số lượng",
          key: "quantity",
          thStyle: {
            width: "20%",
            "min-width": "120px",
            "word-break": "break-word",
          },
        },
        {
          label: "Thành tiền",
          key: "totalAmount",
          thStyle: {
            width: "15%",
            "min-width": "110px",
            "word-break": "break-word",
          },
        },
        {
          label: "",
          key: "fieldEdit",
          thStyle: { width: "5%" },
        },
      ],
      inforMerchant: JSON.parse(localStorage.getItem("auth.currentMerchant")),
      dataItems: [],
      printBarcodeVisible: false,
      dataBaseProducts: [],
    };
  },

  async created() {
    this.loading = true;

    this.locations = await this.getListLocation();
    const resSuppLiers = await this.getSuppliers();
    await this.getListVariation(this.paramItems);
    if (this.query.categoryId && this.query.itemId && this.query.itemPriceId) {
      await this.getItemInfor();
    }

    this.loading = false;
    this.suppliers = resSuppLiers.map((e) => {
      return { ...e, value: e.id };
    });
    const result = this.locations.find(
      (location) => location.coLocationId === this.locationID
    );
    this.inventories = result.inventories;
    this.inventoryName = result.inventories[0].name;

    console.log(2222)
    console.log(this.inventories)
    console.log(this.inventoryID)
  },

  watch: {
    locationID() {
      const result = this.locations.find(
        (location) => location.coLocationId === this.locationID
      );
      this.inventories = result.inventories;
      this.inventoryID = result.inventories[0].coInventoryId;
      this.inventoryName = result.inventories[0].name;
      
      console.log(11111)
      console.log(this.inventories)
      console.log(this.inventoryID)
    },

    "Order.partyB": function () {
      this.validate.errorPartyB = "";
    },
  },
  computed: {
    allowDisplay() {
      return this.selected.length > 0;
    },
  },
  methods: {
    onBatchs(obj) {
      const item = obj.item;
      const batchs = obj.batchs.map((batch) => {
        return {
          ...batch,
          quantityChoose: batch.quantity,
          value: batch.batchCode,
        };
      });
      const findItem = this.Order.lineItem.find(
        (product) => product.variationId === item.variationId
      );
      if (findItem) {
        findItem.expirationSelect.push(...batchs);
        findItem.quantity = findItem.expirationSelect.reduce((a, b) => {
          return a + Number(b.quantityChoose);
        }, 0);
      }
      this.calculateTotalAmount();
    },
    onBatchSelect(obj) {
      const item = obj.item;
      const batchs = obj.batchs;
      const findItem = this.Order.lineItem.find(
        (product) => product.variationId === item.variationId
      );
      if (findItem) {
        findItem.expirationSelect = batchs;
        findItem.quantity = findItem.expirationSelect.reduce((a, b) => {
          return a + Number(b.quantityChoose);
        }, 0);
      }
      this.calculateTotalAmount();
    },
    handleCloseExp(val, item) {
      const checkIndex = item.expirationSelect.findIndex(
        (exp) => exp.value === val.value
      );
      if (checkIndex !== -1) {
        item.expirationSelect.splice(checkIndex, 1);
        item.quantity = item.expirationSelect.reduce((a, b) => {
          return a + Number(b.quantityChoose);
        }, 0);
      }
      this.calculateTotalAmount();
    },
    handleSearchVariation(queryString, cb) {
      let result = [...this.variations].filter((varia) => {
        return (
          varia.name.toLowerCase().indexOf(queryString.toLowerCase()) !== -1 ||
          varia.upc.toLowerCase().indexOf(queryString.toLowerCase()) !== -1 ||
          varia.sku.toLowerCase().indexOf(queryString.toLowerCase()) !== -1 ||
          varia.itemName.toLowerCase().indexOf(queryString.toLowerCase()) !== -1
        );
      });
      cb(result);
    },
    onResponse(arrs) {
      this.Order.lineItem = [];
      this.formatResponeForVariation(arrs, "quickAdd");
    },
    onResult(obj) {
      this.Order.lineItem.forEach((line) => {
        const check = this.selected.find(
          (select) => select.variationId === line.variationId
        );
        if (check) {
          if (obj.type === "price") {
            line.prices.importPrice = obj.value;
          } else {
            if (!line.useImeiAndSerial) {
              line.quantity = obj.value;
            }
          }
        }
      });
      this.calculateTotalAmount();
    },
    checkItem(obj) {
      const checkExist = this.selected.findIndex(
        (select) => select.variationId === obj.variationId
      );
      if (checkExist === -1) {
        this.selected.concat(obj);
      }
      if (this.selected.length === this.Order.lineItem.length) {
        this.checkboxAll = true;
        this.selectAll();
      } else {
        this.checkboxAll = false;
      }
    },
    selectAll() {
      if (this.checkboxAll) {
        this.selected = this.Order.lineItem;
      } else {
        this.selected = [];
      }
    },
    handleChangeImportPrice(obj) {
      const importPrice = removeDot(obj.prices.importPrice);
      const quantity = removeDot(obj.prices.quantity);
      obj.amount = importPrice * quantity;
      obj.totalAmount = obj.amount;
      obj.unitPrice = importPrice;
    },
    returnDetail() {
      this.printBarcodeVisible = false;
      this.successLinkTo();
    },

    submitForm() {
      this.hidePopup("Canh-bao-xac-nhan-phieu-hang");
      this.bntCheckIn("success");
    },

    backLinkTo() {
      if (this.itemID) {
        this.$router.push(`/items`);
      } else {
        this.$router.push(`/inventory-checkin`);
      }
    },

    successLinkTo() {
      if (this.typeSubmit === "success") {
        this.$router.push(`/storage-import/${this.orderID}`);
      } else {
        this.$router.push(`/storage-detail/${this.orderID}`);
      }
    },

    calculateTotalAmount() {
      this.totalAmount = 0;
      if (this.Order.lineItem.length > 0) {
        this.Order.lineItem.map((item) => {
          const importPrice = item.prices
            ? this.checkNumReplaceComma(item.prices.importPrice)
            : 0;
          const quantity = this.checkNumReplaceComma(item.quantity);
          const totalAmount = parseInt(quantity) * parseInt(importPrice);
          item.totalAmount = totalAmount;
          item.amount = totalAmount;
          item.unitPrice = importPrice;
          //Total count
          this.totalAmount += parseInt(totalAmount);
        });
      }
    },

    changeFieldVariation(data) {
      const importPrice = data.prices
        ? this.checkNumReplaceComma(data.prices.importPrice)
        : 0;

      return {
        ...data,
        btnLoading: false,
        variationID: data.variationId,
        addedAmount: [],
        discount: [],
        useImeiAndSerial: data.useImeiAndSerial,
        useProductBatch: data.useProductBatch,
        _showDetails: data.useImeiAndSerial || data.useProductBatch,
        itemInstance: {},
        itemInstanceName: data.itemName,
        variationName: data.variationName,
        lineItemId: data.itemID,
        serieNew: "",
        lineItemOtherInfo: {
          inventoryId: this.inventoryID,
          seriesNo: [],
          validate: "",
        },
        quantity: 0,
        validate: {
          quantity: "",
        },
        amount: 0,
        note: "",
        seriesNo: [],
        tax: [],
        totalAmount: 0,
        unitPrice: importPrice,
        fieldEdit: "",
      };
    },

    removeVariation(index) {
      this.Order.lineItem.splice(index, 1);
      this.calculateTotalAmount();
    },

    addVariation(variation) {
      const result = this.Order.lineItem.find((e) => {
        return e.variationID === variation.variationId;
      });
      if (!result) {
        this.Order.lineItem.push(
          this.changeFieldVariation({
            ...variation,
            expirationSelect: [],
            quantity: variation.useProductBatch ? 0 : variation.quantity,
          })
        );
      }
    },

    async btnAddSeria(index, serieNew) {
      let lineItem = this.Order.lineItem[index].lineItemOtherInfo;
      this.Order.lineItem[index].btnLoading = true;
      lineItem.validate = "";

      // CHECK DUBLICATE FOR ALL VARIATION & DATABASE
      const resultDB = await checkSerialExist(serieNew);
      const resultORDER = this.Order.lineItem.find((variation) => {
        const checkDub = variation.lineItemOtherInfo.seriesNo.findIndex(
          (ser) => ser.trim().toLowerCase() === serieNew.trim().toLowerCase()
        );
        return checkDub != -1;
      });

      this.Order.lineItem[index].btnLoading = false;

      if (resultORDER || resultDB.data.length > 0) {
        lineItem.validate = "Seria/Emei đã tồn tại";
        return;
      } else if (!validSeria(serieNew.trim()) && serieNew != "") {
        lineItem.validate =
          "Độ dài của serial/imei là từ 3 - 25 ký tự, viết liền, không chứa ký tự đặc biệt trừ “-” và “_”";
        return;
      } else if (serieNew.trim() === "") {
        return;
      }

      lineItem.seriesNo.push(serieNew);
      this.Order.lineItem[index].quantity = lineItem.seriesNo.length;
      this.Order.lineItem[index].serieNew = "";
      this.calculateTotalAmount();
    },
    handleClose() {
      console.log("oke");
    },
    handleCloseSeria(val, index) {
      const serials = this.Order.lineItem[index].lineItemOtherInfo.seriesNo;
      const checkIndex = serials.findIndex((serie) => serie === val);
      if (checkIndex === -1) {
        this.$message.error("Seria/Emei không tồn tại");
        return;
      }
      serials.splice(checkIndex, 1);
      this.Order.lineItem[index].quantity = serials.length;
      this.calculateTotalAmount();
    },

    async getItemInfor() {
      let res = {...this.query}
      const dataItem = await this.getDetail(res);
      if (dataItem.variations) {
        const { variations, itemId, metaSearchable, unit, name } = dataItem;
        this.Order.lineItem = variations.map((variation) => {
          return this.changeFieldVariation({
            ...variation,
            itemID: itemId,
            unit: unit,
            itemName: name,
            variationName: variation.name,
            useImeiAndSerial: metaSearchable.useImeiAndSerial === "true",
            useProductBatch: metaSearchable.useProductBatch === "true",
            expirationSelect: [],
            _showDetails: metaSearchable.useProductBatch === "true",
          });
        });
      }
    },
    formatResponeForVariation(arrs, type) {
      if (arrs.length > 0) {
        arrs.map((item) => {
          item.variations.map((variation) => {
            let quantityInven = 0;
            let stockQuantities = variation.stockQuantities.find(
              (stockQuantitie) => stockQuantitie.type === "NSH_ITEM_SALE"
            );
            if (stockQuantities != undefined) {
              const inventoryDatas = stockQuantities?.inventoryDatas
                ? stockQuantities.inventoryDatas
                : [];
              const OneInventory = inventoryDatas.find(
                (stock) => stock.inventoryId === this.inventoryID
              );
              if (OneInventory != undefined) {
                quantityInven = OneInventory.quantity;
              }
            }

            let importPrice = 0;
            let exportPrice = 0;
            variation.prices.map((vl, idx) => {
              if (vl.priceTypeCode === "PRICE_IMPORT") {
                importPrice = this.formatMoneyNotUnit(
                  this.divisionThousand(variation.prices[idx].amount)
                );
              }
              if (vl.priceTypeCode === "PRICE_EXPORT") {
                exportPrice = this.formatMoneyNotUnit(
                  this.divisionThousand(variation.prices[idx].amount)
                );
              }
            });

            const variationTransfer = {
              ...variation,
              quantity: quantityInven,
              itemName: item.name,
              variationName: variation.name,
              value: variation.name,
              itemID: item.itemId,
              unit: item.unit,
              useImeiAndSerial: item.metaSearchable.useImeiAndSerial === "true",
              useProductBatch: item.metaSearchable.useProductBatch === "true",
              prices:
                variation.prices.length > 0
                  ? {
                      name: variation.name,
                      exportPrice: exportPrice,
                      importPrice: importPrice,
                    }
                  : {
                      name: variation.name,
                      exportPrice: 0,
                      importPrice: 0,
                    },
            };
            if (type === "quickAdd") {
              this.addVariation(variationTransfer);
              this.calculateTotalAmount();
            } else {
              this.variations.push(variationTransfer);
            }
          });
        });
      }
    },
    async getListVariation(param) {
      try {
        let response = await ProductService.getList(param);

        if (response.status === 200) {
          this.formatResponeForVariation(response.data);
          this.dataBaseProducts.push(...response.data);
          if (response.data.length > 99 && this.itemID === undefined) {
            this.getListVariation({
              ...this.paramItems,
              pagingAndSorting: {
                ...this.paramItems.pagingAndSorting,
                lastIndex: response.data[99].itemId,
              },
            });
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    getListSupplier(data) {
      if (data != null) {
        this.suppliers = data;
        this.Order.partyB = data[0];
      }
      this.isPopupAddSupplier = false;
    },

    async getListProduct(data) {
      if (data != null) {
        const variation = data.item.variations[0];
        const variationPrice = data.itemPrice.price;

        let importPrice = 0;
        let exportPrice = 0;
        variationPrice.map((vl, idx) => {
          if (vl.priceTypeCode === "PRICE_IMPORT") {
            importPrice = this.formatMoneyNotUnit(
              this.divisionThousand(variationPrice[idx].amount)
            );
          }
          if (vl.priceTypeCode === "PRICE_EXPORT") {
            exportPrice = this.formatMoneyNotUnit(
              this.divisionThousand(variationPrice[idx].amount)
            );
          }
        });

        const variationTmp = {
          ...variation,
          itemName: data.item.name,
          variationName: variation.name,
          variationId: variation.itemVariationId,
          itemID: data.item.id,
          useImeiAndSerial: false,
          unit: data.item.unit,
          prices: {
            name: variation.name,
            exportPrice: exportPrice,
            importPrice: importPrice,
          },
        };
        this.variations.unshift(variationTmp);
        this.addVariation(variationTmp);
      }
      this.isPopupAddItem = false;
    },

    async validateHandler() {
        const result = await this.searchOrderNo(this.Order.orderNo);
        this.$refs.storageCreat.validate();
        if (this.Order.partyB.id === undefined) {
          this.validate.errorPartyB = "Vui lòng chọn nhà cung cấp";
        }

        if (result.data.length > 0 && this.Order.orderNo != "") {
          this.validate.orderNo =
            "Mã đơn nhập kho không được trùng, vui lòng nhập mã đơn khác!";
        } else {
          this.validate.orderNo = "";
        }

        if (this.Order.lineItem.length === 0) {
          this.loading = false;
          this.showPopup("Chua-nhap-san-pham");
        }

        this.Order.lineItem = this.Order.lineItem.map((e) => {
          return {
            ...e,
            validate: {
              quantity: e.useImeiAndSerial
                ? ""
                : this.checkNumReplaceComma(e.quantity) === 0
                ? "Vui lòng nhập số lượng"
                : "",
            },
            lineItemOtherInfo: {
              ...e.lineItemOtherInfo,
              validate:
                e.lineItemOtherInfo.seriesNo.length === 0
                  ? "Vui lòng nhập serial cho sản phẩm"
                  : "",
            },
          };
        });
    },

    checkSubmit(formName, type) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.bntCheckIn(type);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    
    async bntCheckIn(type) {
      try {
        this.loading = true;
        await this.validateHandler();
        await this.sleep(500);
        let el = document.querySelector(".is-invalid");
        let el2 = document.querySelector(".is-valid-table");
        const validExpiredSelect = this.Order.lineItem.filter((item) => {
          return item.useProductBatch && item.expirationSelect.length === 0;
        });
        if (validExpiredSelect.length > 0) {
          this.loading = false;
          el2.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          el2.focus();
          this.$notify({
            type: "warning",
            title: "Thông báo",
            message: "Hãy chọn số lô - hạn sử dụng cho phiên bản",
          });
          return;
        }
        if (el) {
          this.loading = false;
          el.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          el.focus();
          return;
        }
        if (!(el && validExpiredSelect.length > 0)) {
          if (this.Order.lineItem.length > 0) {
            try {
              const param = await this.reqCheckinOrder({
                ...this.Order,
                locationId: this.locationID,
                inventoryId: this.inventoryID,
                inventoryName: this.inventoryName,
              });

              const response = await StorageService.storageCheckInOrder(param);

              this.orderID = response.data.id;

              if (response.success && type == "success") {
                await this.changeStatusOrder(
                  response.data.id,
                  "DRAFT",
                  "PROCESSING"
                );
                this.typeSubmit = "success";
                this.showPopup("checkin-success");
              } else if (response.success && type == "draft") {
                this.showPopup("checkin-success");
                this.typeSubmit = "draft";
              }

              this.loading = false;
            } catch (error) {
              console.log(error);
            }
          }
        }
      } catch (error) {
        this.loading = false;
      }
    },
    clickBarcodeChooseMore() {
      this.printBarcodeVisible = false;
      if (this.Order.lineItem.length > 0) {
        this.Order.lineItem.map((item) => {
          const oneItem = {
            amount: this.checkNumReplaceComma(item.prices.exportPrice),
            images: item.images,
            itemVariationId: item.variationId,
            lineItemId: item.lineItemId,
            mcName: this.inforMerchant.name,
            name: item.variationName,
            quantity: this.checkNumReplaceComma(item.quantity),
            sku: item.sku,
            unitPrice: this.checkNumReplaceComma(item.prices.exportPrice),
            upc: item.upc,
          };
          this.dataItems.push(oneItem);
        });
        this.saveStorage();
        this.$router.push({ path: "/barcode/choose" });
      }
    },
    saveStorage() {
      localStorage.setItem("itemBarcode", JSON.stringify(this.dataItems));
    },
    changeLocationID() {
      this.variations = [];
      this.formatResponeForVariation(this.dataBaseProducts);
    },
  },
};
</script>

<style lang="scss" scoped>
.inventory-create {
  .total-amount {
    font-size: 16px;
    font-weight: bold;
    display: flex;
    justify-content: flex-end;
    width: 100%;
    padding-top: 10px;
  }

  .el-input__inner {
    color: #111;
  }

  .el-card__header {
    border-bottom: none;
  }

  .el-select {
    width: 100%;
  }

  .tag {
    margin: 0 3px;
  }

  .is-invalid {
    color: red;
  }

  .icon-success {
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
  }

  .content-success {
    display: flex;
    justify-content: center;
    font-size: 14px;
    line-height: 22.4px;
    font-weight: 400;
    color: #3c3e49;
  }

  .emptyTable {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 24px 0px;

    p {
      margin: 10px 0px 0px 0px;
      color: #808890;
    }
  }
}
</style>
